/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokens
 */
export interface FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokens {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokens
     */
    RefreshToken: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokens
     */
    GameAccessToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokens
     */
    AccessToken?: string | null;
}

/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokens interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokens(value: object): value is FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokens {
    if (!('RefreshToken' in value) || value['RefreshToken'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokensFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokens {
    return FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokensFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokensFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokens {
    if (json == null) {
        return json;
    }
    return {
        
        'RefreshToken': json['RefreshToken'],
        'GameAccessToken': json['GameAccessToken'] == null ? undefined : json['GameAccessToken'],
        'AccessToken': json['AccessToken'] == null ? undefined : json['AccessToken'],
    };
}

export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokensToJSON(json: any): FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokens {
    return FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokensToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokensToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokens | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'RefreshToken': value['RefreshToken'],
        'GameAccessToken': value['GameAccessToken'],
        'AccessToken': value['AccessToken'],
    };
}

